module.exports = __webpack_public_path__ + "img/image129.38c159d2.png";